import API from "serviceshift-ui/api-client";

export default {
  fetchDashboardData({ commit, dispatch }, filters) {
    commit("replace", {
      state: "dashboardLoading",
      data: true
    });
    Promise.all([
      dispatch("fetchOpportunitiesChart", filters).catch(() =>
        window.notify.error("Unable to load Opportunities")
      ),
      dispatch("fetchRevenueChart", filters).catch(() =>
        window.notify.error("Unable to load Revenue")
      ),
      dispatch("fetchMembershipsSoldChart", filters).catch(() =>
        window.notify.error("Unable to load Memberships Sold")
      ),
      dispatch("fetchTechLeaderboard", filters).catch(() =>
        window.notify.error("Unable to load Tech Leaderboard")
      ),
      dispatch("fetchPerformanceSummary", filters).catch(() =>
        window.notify.error("Unable to load Performance Summary")
      )
    ])
      .then((values) => {
        commit("replace", {
          state: "dashboardData",
          data: {
            opportunities: (values[0] || {}).data,
            revenue: (values[1] || {}).data,
            memberships: (values[2] || {}).data,
            leaderboard: (values[3] || {}).data,
            summary: (values[4] || {}).data
          }
        });
        commit("replace", {
          state: "dashboardLoading",
          data: false
        });
      })
      .catch(() => {
        commit("replace", {
          state: "dashboardLoading",
          data: false
        });
      });
  },
  fetchOpportunitiesChart(_, filters) {
    return API.makeRequest("/v2/metrics/series/opportunity_count", {
      method: "GET",
      params: filters
    });
  },
  fetchRevenueChart(_, filters) {
    return API.makeRequest("/v2/metrics/series/job_revenue", {
      method: "GET",
      params: filters
    });
  },
  fetchMembershipsSoldChart(_, filters) {
    return API.makeRequest("/v2/metrics/series/memberships_sold", {
      method: "GET",
      params: filters
    });
  },
  fetchTechLeaderboard(_, filters) {
    return API.makeRequest("/v2/metrics/technician_leaderboard", {
      method: "GET",
      params: filters
    });
  },
  fetchPerformanceSummary(_, filters) {
    return API.makeRequest("/v2/metrics/performance_summary", {
      method: "GET",
      params: filters
    });
  },
  setDashboardFilters({ commit, dispatch, state }, filters) {
    const previousFilters = { ...state.dashboardFilters };
    const filtersChanged =
      JSON.stringify(previousFilters) !== JSON.stringify(filters);
    if (filters.department_id) {
      filters.department_id = filters.department_id.join(",");
    }
    commit("update", {
      state: "dashboardFilters",
      data: filters
    });
    const { base_range, comparison_range, granularity } =
      state.dashboardFilters;
    if (filtersChanged && base_range && comparison_range && granularity) {
      dispatch("fetchDashboardData", state.dashboardFilters);
    }
  },
  clearDashboardData({ commit }) {
    commit("replace", {
      state: "dashboardData",
      data: {
        opportunities: null,
        revenue: null,
        memberships: null,
        leaderboard: null,
        summary: null
      }
    });
  }
};
